import React, {Component} from "react";
import {Accordion, Button, Col, Container, Image, Row, Tab, Tabs} from "react-bootstrap";
import * as utils from "../../utils.js";
import DesplegableDatosCanonicos from "./desplegables/desplegable_datos_canonicos";
import DesplegableDatosCiviles from "./desplegables/desplegable_datos_civiles";
import DesplegableLocalizacion from "./desplegables/desplegable_localizacion";
import {Link} from "react-router-dom";
import {DesplegableRepresentantesLegales} from "./desplegables/desplegable_representantes_legales.jsx";

import Cargos from "../cargos/Cargos.jsx";

export default class ProvinciaDetalle extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // Datos que serán asignados en los get
      DatosProvincia: "",
      // Array que contiene si se muestran o no los modales
      showModalArray: [],
    };

    this.handleButtonShow = this.handleButtonShow.bind(this);
    this.nullField = this.nullField.bind(this);
    this.setInformacionOrganismo = this.setInformacionOrganismo.bind(this);
  }

  async componentDidMount() {
    let cstate = this.state;
    // TODO no deberiamos coger el id del computedMatch sino del enrutador que lo cogeria del match

    let id_provincia = this.props.ruta === "DireccionGeneral" ? "14" : this.props.computedMatch.params.id_p;

    cstate.DatosProvincia = await utils.callAjaxGet("GET", process.env.REACT_APP_API_URL + "/provincias/" + id_provincia, this.props.ErrorHandling);

    // cstate.RepresentantesLegales = await utils.callAjaxGet("GET", process.env.REACT_APP_API_URL + "/provincias/" + cstate.DatosProvincia.id + "/representantesLegales", this.props.ErrorHandling);

    // cstate.ServiciosProvinciales = await utils.callAjaxGet("GET", process.env.REACT_APP_API_URL + "/provincias/" + cstate.DatosProvincia.id + "/serviciosProvinciales", this.props.ErrorHandling);

    // Inicializamos la array modal que sirve para controlar los modales que se muestran
    cstate.showModalArray.push(false); // [0] controla modal información canónica
    cstate.showModalArray.push(false); // [1] controla modal datos civiles
    cstate.showModalArray.push(false); // [2] controla modal localización
    cstate.showModalArray.push(false); // [3] controla modal representantes legales

    this.setState(cstate);
  }

  // Método Set, se encargan de actualizar el estado de este componente cuando se edita en los hijos
  setInformacionOrganismo(response) {
    this.setState({ DatosProvincia: response });
  }

  // Funcion que se encarga de controlar el array de los modales
  handleButtonShow(event) {
    // Creamos una matriz auxiliar
    let showModalArrayAux = this.state.showModalArray;

    // Recibimios un id que se corresponde con la posicion del array
    // en la que se encuentra el showModal.

    if (event) {
      showModalArrayAux[event.target.id] = !this.state.showModalArray[event.target.id];
    }

    //Si el evento es nulo o es cerrar ponemos todo a false
    if (event === undefined || event.target.name === "Cerrar") {
      for (let i = 0; i < showModalArrayAux.length; i++) {
        showModalArrayAux[i] = false;
      }
    }
    this.setState({
      showModalArray: showModalArrayAux,
    });
  }

  // Función que cambia una variable del estado a null tambn se hace a dos niveles, en caso de foto la pone por defecto
  nullField(field, secondOrder) {
    let cstate = this.state;
    if (secondOrder === "photo") {
      cstate.DatosProvincia.photo = "/images/logoSTJ.png";
    } else if (secondOrder !== null) {
      cstate.DatosProvincia[secondOrder][field] = null;
    } else {
      cstate.DatosProvincia[field] = null;
    }
    this.setState(cstate);
  }

  onError(e) {
    let cstate = this.state;
    // Si hay un error cargamos la foto del logo
    e.target.onerror = null;
    e.target.src = "/images/logoSTJ.png";
    cstate.DatosProvincia.photo = "/images/logoSTJ.png";

    this.setState(cstate);
  }

  render() {
    let datosProvincia = this.state.DatosProvincia ? (
      <Container>
        <Row bg="light" className="shadow-lg mx-3 my-5 align-items-center p-1">
          <Col className="d-flex justify-content-center" xs={12} sm={12} lg={6}>
            <Image
              className="img-fluid-detalle"
              variant="top"
              src={
                this.state.DatosProvincia.photo
                  ? process.env.REACT_APP_API_URL + "/download/provincias/" + this.state.DatosProvincia.id + "?aux=" + this.state.DatosProvincia.photo
                  : "/images/logoSTJ.png"
              }
              onError={(e) => this.onError(e)}
              alt="provinceImg"
            />
          </Col>
          <Col xs={12} sm={12} lg={6} className="text-center">
            <h5 className="detail-title-sister">{this.state.DatosProvincia.name}</h5>
            {this.props.ruta === "DireccionGeneral" ? (
              ""
            ) : (
              <Link
                to={{
                  pathname: "/provincias/" + this.state.DatosProvincia.id + "/comunidades",
                }}
              >
                <Button variant="outline-primary" className={"mr-1"}>
                  Comunidades
                </Button>
              </Link>
            )}

            <Link
              to={{
                pathname: this.props.ruta === "DireccionGeneral" ? "/direccionGeneral/gruposTrabajo" : "/provincias/" + this.state.DatosProvincia.id + "/gruposTrabajo",
              }}
            >
              <Button variant="outline-secondary" className={"mr-1"}>
                Equipos/Comisiones
              </Button>
            </Link>
            {this.props.ruta !== "DireccionGeneral" && (
              <Link
                to={{
                  pathname: `/provincias/${this.state.DatosProvincia.id}/mision`,
                }}
              >
                <Button variant="outline-info" className={"mr-1"}>
                  Misión
                </Button>
              </Link>
            )}
          </Col>
        </Row>

        <Row>
          <Col>
            <Tabs>
              <Tab eventKey="organismo" title="Información del Organismo">
                <Accordion>
                  <DesplegableDatosCanonicos
                      state={this.state}
                      handleButtonShow={this.handleButtonShow}
                      setInformacionOrganismo={this.setInformacionOrganismo}
                      setAlert={this.props.setAlert}
                      ErrorHandling={this.props.ErrorHandling}
                      nullField={this.nullField}
                  />
                  <DesplegableDatosCiviles
                      state={this.state}
                      handleButtonShow={this.handleButtonShow}
                      setInformacionOrganismo={this.setInformacionOrganismo}
                      setAlert={this.props.setAlert}
                      ErrorHandling={this.props.ErrorHandling}
                      nullField={this.nullField}
                  />
                  <DesplegableLocalizacion
                      state={this.state}
                      handleButtonShow={this.handleButtonShow}
                      setInformacionOrganismo={this.setInformacionOrganismo}
                      setAlert={this.props.setAlert}
                      ErrorHandling={this.props.ErrorHandling}
                      nullField={this.nullField}
                  />
                  <DesplegableRepresentantesLegales
                      state={this.state}
                      handleButtonShow={this.handleButtonShow}
                      setInformacionOrganismo={this.setInformacionOrganismo}
                      setAlert={this.props.setAlert}
                      ErrorHandling={this.props.ErrorHandling}
                      nullField={this.nullField}
                      id_provincia={this.props.ruta === "DireccionGeneral" ? "14" : this.props.computedMatch.params.id_p}
                      DireccionGeneral={this.props.ruta === "DireccionGeneral"}
                  />
                </Accordion>
              </Tab>
              <Tab eventKey="gobierno" title={this.props.ruta === "DireccionGeneral" ? "Gobierno General" : "Gobierno Provincial"}>
                <Cargos
                  type={this.props.ruta === "DireccionGeneral" ? "gobiernoGeneral" : "gobiernoProvincial"}
                  idEntidad={this.props.ruta === "DireccionGeneral" ? "14" : this.props.computedMatch.params.id_p}
                />
              </Tab>
              <Tab eventKey="oficios" title={this.props.ruta === "DireccionGeneral" ? "Oficios Generales" : "Oficios Provinciales"}>
                <Cargos
                  type={this.props.ruta === "DireccionGeneral" ? "oficiosGenerales" : "oficiosProvinciales"}
                  idEntidad={this.props.ruta === "DireccionGeneral" ? "14" : this.props.computedMatch.params.id_p}
                />
              </Tab>
              <Tab eventKey="otrosServicios" title={this.props.ruta === "DireccionGeneral" ? "Otros Servicios Generales" : "Otros Servicios Provinciales"}>
                <Cargos
                  type={this.props.ruta === "DireccionGeneral" ? "otrosServiciosGenerales" : "otrosServiciosProvinciales"}
                  idEntidad={this.props.ruta === "DireccionGeneral" ? "14" : this.props.computedMatch.params.id_p}
                />
              </Tab>
            </Tabs>
          </Col>
        </Row>
      </Container>
    ) : null;
    return <React.Fragment>{datosProvincia}</React.Fragment>;
  }
}
